
const lazy = {
    created(el, binding) {
      if(binding.value) {
        let l = binding.value;
        el.classList.add('pre-show')
        if(typeof IntersectionObserver === "undefined" || !('isIntersecting' in IntersectionObserverEntry.prototype)) {
          el.src = l;
          el.classList.add('is-show');
          return;
        }
  
        var io = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              el.src = l;
              el.classList.add('is-show');
              //console.log('created show', el.src)
              observer.disconnect();
            }
          });
        });
        io.observe(el)
      }
    },
    updated(el, binding) {
      if(binding.value) {
        let l = binding.value;
        if(typeof IntersectionObserver === "undefined" || !('isIntersecting' in IntersectionObserverEntry.prototype)) {
          el.src = l;
          el.classList.add('is-show');
          return;
        }
  
        var io = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              el.src = l;
              el.classList.add('is-show');
              //console.log('updated show', el.src)
              observer.disconnect();
            }
          });
        });
        io.observe(el)
      }
    }
  }
  
  export default lazy;  